import i18next from 'i18next';
import * as yup from 'yup';

export const RequiredForBusiness = yup.string().when('personType', {
  is: (personType: any) => personType?.code === 'business', // Si ES jurídico (02)
  then: (schema) => schema.required(i18next.t('common.validations.fieldRequired')),
  otherwise: (schema) => schema.notRequired()
});

export const RequiredForIndividual = yup.string().when('personType', {
  is: (personType: any) => personType?.code === 'individual', // Si ES natural (01)
  then: (schema) => schema.required(i18next.t('common.validations.fieldRequired')),
  otherwise: (schema) => schema.notRequired()
});

export const RuleRequiredPersonType = yup
  .object()
  .required(i18next.t('common.validations.fieldRequired'))
  .typeError(i18next.t('common.validations.fieldRequired'));
